module.exports = __webpack_public_path__ + "img/establishment-open.8d592ce2.svg";